import { call, put, takeLatest, all } from 'redux-saga/effects';
import history from '@history';
import { showToast } from 'app/store/actions/fuse';
import * as Actions from '../../actions';
import applicationService from 'app/services/applicationsService';

function* fetchApplication(action) {
	try {
		const response = yield call(() => applicationService.fetchApplication(action.payload));
		yield put(Actions.fetchApplicationSuccess(response.data));
	} catch (error) {
		yield put(showToast.error('Unable to Retrieve Application ' + error));
		yield put(Actions.fetchApplicationFailure());
	}
}

function* createApplication(action) {
	try {
		const response = yield call(() => applicationService.createApplication(action.payload));
		yield put(Actions.createApplicationSuccess(response.data));
		history.push(`/applications/${response.data.id}/edit`);
		yield put(showToast.success('Application Saved'));
	} catch (error) {
		yield put(
			showToast.error(`Unable to Save Application: 
                      ${error && error.response && error.response.data ? error.response.data.split('\n')[0] : ''}`)
		);
		yield put(Actions.createClientFailure());
	}
}

function* updateApplication(action) {
	try {
		const response = yield call(() => applicationService.updateApplication(action.payload));
		yield put(Actions.updateApplicationSuccess(response.data));
		yield put(showToast.success('Application Updated'));
	} catch (error) {
		yield put(
			showToast.error(`Unable to Update Application: 
                      ${error && error.response && error.response.data ? error.response.data.split('\n')[0] : ''}`)
		);
		yield put(Actions.updateClientSuccess());
	}
}

function* deleteApplication(action) {
	try {
		const response = yield call(() => applicationService.deleteApplication(action.payload));
		yield put(Actions.deleteApplicationSuccess(response.data));
		history.push('/applications');
		yield put(showToast.success('Application Deleted'));
	} catch (error) {
		yield put(showToast.error('Unable to Delete Application'));
		console.log(error);
		yield put(Actions.deleteApplicationFailure());
	}
}

function* watchApplication() {
	yield all([
		takeLatest(Actions.fetchApplication, fetchApplication),
		takeLatest(Actions.createApplication, createApplication),
		takeLatest(Actions.updateApplication, updateApplication),
		takeLatest(Actions.deleteApplication, deleteApplication)
	]);
}

export default watchApplication;
